import React, { useState, Fragment } from 'react';
import HotKeysModal from 'Components/HotKeysModal';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { langCheck, handleExternalLinkUrl } from "Pub/js/utils";
import { getCurrentLangIndex, getMultiLangValue } from "Pub/js/getMulti";
import platform from "Pub/js/platform";
import externalLinkIcon from 'Pub/js/externalLinkIcon';
import Notice from "Components/Notice";
import ImgChooser from 'Components/ImgChooser';
import { APP_DEFAULT_SIZE } from "Pages/NewHome/utilService";
const { NCFormControl, NCButton, NCTooltip, NCMultiLangText } = platform.base;
import { addExternalLink, editExternalLink, urlTest, getImageKey, switchTitleData } from './common';
import selectIcon from 'Assets/images/select-icon.svg';
const { PubSub } = platform;
const defaultNameObj = {
    title: {
        current: false,
        index: "",
        value: ""
    },
    title2: {
        current: false,
        index: "",
        value: ""
    },
    title3: {
        current: false,
        index: "",
        value: ""
    },
}

let AddExternalLink = props => {
    let { setShowAddLink, onOk, externalLinkData = {}, editable = false, isRespWorkbench } = props;
    const title = langCheck("0000PUB-000387"); //多语设置-常用链接
    const icons = [
        { imgSrc: externalLinkIcon.externallinkicon1, key: 'externallinkicon1' },
        { imgSrc: externalLinkIcon.externallinkicon2, key: 'externallinkicon2' },
        { imgSrc: externalLinkIcon.externallinkicon3, key: 'externallinkicon3' },
        { imgSrc: externalLinkIcon.externallinkicon4, key: 'externallinkicon4' },
        { imgSrc: externalLinkIcon.externallinkicon5, key: 'externallinkicon5' },
        { key: 'custom-upload' },
    ];
    const [iconArray, setIconArry] = useState(icons);
    // 名称改成多语文本框 需要做兼容
    let newName = externalLinkData && externalLinkData.name;
    if (typeof (newName) === 'string' && newName && !externalLinkData.title2) {
        newName = {
            ...defaultNameObj,
            ...getMultiLangValue('title', externalLinkData),
            [`title${getCurrentLangIndex()}`]: {
                current: true,
                index: "",
                value: externalLinkData[`title${getCurrentLangIndex()}`] || newName,
            },
        };
    } else {
        newName = getMultiLangValue('title', externalLinkData);
    }
    const [iptTitle, setIptTitle] = useState(newName || '');
    let [iptUrl, setIptUrl] = useState(externalLinkData.url === 'null' ? '' : externalLinkData.url || '');
    // let [autoFocus, setAutoFocus] = useState(false)
    const languageMetas = window.GETBUSINESSINFO() && window.GETBUSINESSINFO().languageMetas;
    let iconType = 'externallinkicon1';
    if (JSON.stringify(externalLinkData) != '{}') {
        iconType = getImageKey(externalLinkData);
        if (iconType.startsWith('data:image/')) { // 自定义的
            iconType = 'custom-upload';
            const customIcon = iconArray.find(item => item.key === 'custom-upload');
            customIcon.imgSrc = externalLinkData.image;
        }
    }
    const [selectKey, setSelectKey] = useState(iconType);
    // 通用外部链接数据
    const generalData = ({ iptTitle, iptUrl, selectKey, cardid }) => {
        const inputContent = {
            appcode: '10182004',
            apptype: '2',
            // name: iptTitle,
            url: iptUrl,
            urllink: iptUrl,
            image: selectKey === 'custom-upload' ? iconArray.find(item => item.key === 'custom-upload').imgSrc : selectKey,
            cardid,
            width: APP_DEFAULT_SIZE.width,
            height: APP_DEFAULT_SIZE.height,
            ...switchTitleData(iptTitle),
            // ...iptTitle,
        };
        const obj = { ...externalLinkData, ...inputContent };
        return obj;
    };
    // 修改外部链接
    const editExternal = ({ iptTitle, iptUrl, selectKey, pk_group_app }) => {
        const data = {
            pk_group_app,
            // title: iptTitle,
            urllink: iptUrl,
            image: selectKey,
            ...switchTitleData(iptTitle),
        };
        if (selectKey === 'custom-upload') {
            const selectIcon = iconArray.find(item => item.key === selectKey);
            if (!selectIcon.imgSrc) {
                Notice({
                    status: "warning",
                    msg: langCheck('0000PUB-000011'), //"0000PUB-000011": "请选择图标",
                });
                return;
            }
            data.image = selectIcon.imgSrc;
        }
        editExternalLink(props, data).then(res => {
            onOk(generalData({ iptTitle, iptUrl, selectKey, cardid: pk_group_app }));
            setShowAddLink(false); // 关闭外部链接弹框
        });
    };

    const handleOk = () => {
        // const selectArr = iconArray.filter(item => item.key === selectKey);
        // const iconUrl = selectArr && selectArr[0] && selectArr[0].imgSrc;
        if (checkURL(iptUrl.trim()) && checkTitle()) {
            iptUrl = handleExternalLinkUrl(iptUrl);
            if (!editable && isRespWorkbench) {
                PubSub.publish("saveDesktopOutside"); //浏览态保存常用链接后 通知保存桌面
            }
            if (JSON.stringify(externalLinkData) === '{}') {
                const data = {
                    // title: iptTitle,
                    urllink: iptUrl,
                    image: selectKey,
                    ...switchTitleData(iptTitle),
                };
                if (selectKey === 'custom-upload') {
                    const selectIcon = iconArray.find(item => item.key === selectKey);
                    if (!selectIcon.imgSrc) { return; }

                    data.image = selectIcon.imgSrc;
                }
                addExternalLink(props, data).then(res => {
                    if (res) {
                        onOk(generalData({ iptTitle, iptUrl, selectKey, cardid: res.pk_group_app }));
                        setShowAddLink(false);
                    }
                });
            } else {
                const pk_group_app = externalLinkData.pk_group_app;
                if (!editable) {
                    editExternal({ iptTitle, iptUrl, selectKey, pk_group_app });
                } else {
                    if (selectKey === 'custom-upload') {
                        const selectIcon = iconArray.find(item => item.key === selectKey);
                        if (!selectIcon.imgSrc) { return; }
                    }
                    onOk(generalData({ iptTitle, iptUrl, selectKey, cardid: pk_group_app }));
                    setShowAddLink(false); // 关闭外部链接弹框
                }

            }
        }
    };

    const handleCancel = () => {
        setShowAddLink(false);
    };
    // 标题输入框
    const onChangeTitle = value => {
        setIptTitle(value);
    };
    // url输入框
    const onChangeUrl = value => {
        setIptUrl(value);
    };
    // 验证url方法
    const checkURL = iptUrl => {
        let flag = true;
        if (urlTest(iptUrl)) {
            flag = true;
        } else if (iptUrl.length > 400) {
            Notice({
                status: "warning",
                msg: langCheck('0000PUB-000462'), //'网址字段极值为400，现已超过最大值不能保存'
            });
            flag = false;
        } else if (iptUrl.length === 0) {
            Notice({
                status: "warning",
                msg: langCheck('0000PUB-000464'), //  有必填项未填，不能保存
            });
            flag = false;
        } else {
            Notice({
                status: "warning",
                msg: langCheck('0000PUB-000443'), //  '您输入的url地址无效'
            });
            flag = false;
        }
        return flag;
    };
    // 验证标题
    const checkTitle = () => {
        const currentTitle = iptTitle[`title${getCurrentLangIndex()}`].value;
        if (currentTitle.length && currentTitle.length <= 20) {
            return true;
        } else if (currentTitle.length > 20) {
            Notice({
                status: "warning",
                msg: langCheck('0000PUB-000466'), //'您输入的标题过长，最多支持录入20字符'
            });
            return false;
        } else {
            Notice({
                status: "warning",
                msg: langCheck('0000PUB-000464'), //'您输入的标题无效' 有必填项未填，不能保存
            });
            return false;
        }
    };

    const imgList = () => {
        return (<div className="icon-list-box-right">
            {iconArray.map((item, index) => {
                const isCustom = item.key === 'custom-upload';
                return (
                    <div
                        className={`${item.key === selectKey ? 'isSelect icon-item' : 'icon-item'} ${isCustom ? 'custom' : ''}`}
                        key={item.key}
                        tabIndex="0"
                        onFocus={evt => {
                            if (isCustom) {return;} // 等选完图片再设置选中
                            onSelectIconKeyUp(evt, item);
                        }}
                    >
                        <img className='external-img' src={item.imgSrc} alt="" onClick={() => {
                            if (isCustom) {return;}
                            handleSelectIcon(item);
                        }} />
                        <img className='select-icon' src={selectIcon} alt="" style={item.key === selectKey ? { display: 'block' } : { display: "none" }} />
                        {
                            item.key === 'custom-upload' && <ImgChooser onChange={value => {
                                item.imgSrc = value;
                                setIconArry([...iconArray]);
                                setSelectKey(item.key);
                            }}>
                                <i className='iconfont icon-ncc-sq custom-add'></i>
                            </ImgChooser>
                        }
                    </div>
                );
            })}
        </div>);
    };
    // blob转base64
    const blobToDataURI = (blob, callback) => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (e) {
            callback(e.target.result);
        };
    };
    // tab聚焦选中图标
    const onSelectIconKeyUp = (evt, item) => {
        // let { keyCode } = evt;
        setSelectKey(item.key);
        // // 空格或回车选中
        // let isSelect = keyCode === 13 || keyCode === 32;
        // if (isSelect === true) {
        //     setSelectKey(item.key);
        // }
    };
    // 选中图标
    const handleSelectIcon = e => {
        setSelectKey(e.key);
    };
    // 底部按钮
    const myFooter = ({ CancelBtn }) => {
        return (
            <Fragment>
                <NCTooltip
                    placement="top"
                    overlay={`${langCheck('0000PUB-000007')}(Alt + Y)`}
                >
                    <NCButton
                        key="submit"
                        colors="primary"
                        onClick={handleOk}
                        fieldid="addExternalLink"
                    >
                        {langCheck("0000PUB-000007")/** 多语 保存 */}(<span className="underline">Y</span>)
                    </NCButton>
                </NCTooltip>
                {CancelBtn}
            </Fragment>
        );
    };
    return (
        <HotKeysModal
            // maskClosable={true}
            destroyOnClose={true}
            visible={true}
            title={title}
            footer={myFooter}
            wrapClassName="external-modal"
            className='external-link-box'
            onOk={handleOk}
            modalAutoFocus={false}
            onCancel={handleCancel}
            height={270}
            width={400}
            fieldid='external-link-modal'
        >
            {
                <Fragment>
                    <div className="ipt-box">
                        <span className="title">{langCheck('0000PUB-000445') /** 多语 - 标题 */}</span>
                        <NCMultiLangText
                            className="ipt"
                            fieldid='input-title'
                            value={iptTitle}
                            // value='12412423'
                            // autoFocus
                            attrcode='title'
                            languageMeta={languageMetas}
                            onChange={onChangeTitle}
                            maxlength={60}
                        ></NCMultiLangText>
                        {/* <NCFormControl
                            className="ipt"
                            value={iptTitle}
                            onChange={onChangeTitle}
                            size="sm"
                            autoFocus
                            fieldid='input-title'
                        /> */}
                    </div>
                    <div className="ipt-box ipt-website">
                        <span className="title">{langCheck('0000PUB-000465') /**多语 网址 */}</span>
                        <NCFormControl
                            className="ipt"
                            value={iptUrl}
                            placeholder={langCheck('0000PUB-000463')/** 多语 填写外部链接的访问地址 */}
                            onChange={onChangeUrl}
                            size="sm"
                            fieldid='input-url'
                            showClose
                        />
                    </div>
                    <div className="icon-list-box">
                        <span className="title" >{langCheck('0000PUB-000446') /** 多语 - 图标 */}</span>
                        {imgList()}
                    </div>
                </Fragment>
            }

        </HotKeysModal>
    );
};

AddExternalLink = connect(state => ({
    isSaveComplete: state.gridLayoutData.isSaveComplete,
    isRespWorkbench: state.gridLayoutData.isRespWorkbench,
    editable: state.gridLayoutData.editable,
}))(AddExternalLink);
export default withRouter(AddExternalLink);
